import React from 'react';
import styles from './error.module.scss';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '../buttons/PrimaryButton';
import ErrorSupportLink from './ErrorSupportLink';
import ErrorCode from './ErrorCode';
import FeatherIcon from "feather-icons-react";

interface IProps {
  code?: string
  chooseDifferentBank: () => void
}

const GenericError: React.FC<IProps> = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.screen} data-testid='error-container'>
      <div className={styles.topWrapper}>
          <FeatherIcon icon="alert-triangle" size={40} className={styles.icon} />
        <h1>{t<string>('Something went wrong')}</h1>
        <div >
          <p><>
            {t<string>('Sorry. We encountered an unexpected error.')}
            <ErrorCode errorCode={props.code} /></>
          </p>
          <p><>{t<string>('Please try again. If the problem persists, please contact our')} <ErrorSupportLink errorCode={props.code} /></></p>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <PrimaryButton onClick={props.chooseDifferentBank}>{t<string>('Return to Bank Select')}</PrimaryButton>
      </div>
    </div>
  );
};

export default GenericError;
